import { DashboardFunctions } from '../..';
import { PlaycastMessage, PlaycastRemoteMessages, validators } from '@playcastdotio/Messaging';

export const handleIncomingMessages = (validMessage: PlaycastMessage<PlaycastRemoteMessages>, hostIpcFunctions: DashboardFunctions) => {
  try {
    const action = validMessage.header.action;
    const isReply = validMessage.header.isReply;
    switch (action) {
      case 'sendFunctionCommand':
        if (!isReply) {
          const validatedMessage = validators.remote.sendFunctionCommand(validMessage);
          if (!validatedMessage) {
            console.error('[RC-Handler] Invalid sendFunctionCommand message received');
            return;
          }
          const functionName = validatedMessage.body.message.functionName;
          const functionArgs = validatedMessage.body.message.functionArgs;
          if (hostIpcFunctions[functionName]) {
            hostIpcFunctions[functionName](...functionArgs);
          } else {
            console.error('[RC-Handler] Function not found:', functionName);
          }
        }
        break;
      default:
        console.warn('[RC-Handler] Unhandled message received from remote control client:', action);
    }
  } catch (e) {
    console.error('[RC-Handler] Failed to parse message from remote connection', e);
  }
};
